import React from 'react';
import { Button, Col, InputNumber, Row, Space, Typography } from 'antd';
import PropTypes from 'prop-types';

import { PlayCircleOutlined } from '@ant-design/icons';

import { useTradeBookStore } from '../../../../store';

import SimulationPlanCard from './SimulationPlanCard';

const { Text } = Typography;

export default function SimulationPanel({ plans, tradeCount, onRunSimulation, isLoading }) {
    const { setSimulationTradeCount, updateSimulationPlan } = useTradeBookStore();

    return (
        <div className="simulation-panel">
            <div className="simulation-controls">
                <Space>
                    <Text>Simulate for</Text>
                    <InputNumber
                        min={1}
                        max={100}
                        value={tradeCount}
                        onChange={setSimulationTradeCount}
                        style={{ width: 80 }}
                    />
                    <Text>trades</Text>
                    <Button
                        type="primary"
                        icon={<PlayCircleOutlined />}
                        onClick={onRunSimulation}
                        loading={isLoading}
                    >
                        Run Simulation
                    </Button>
                </Space>
            </div>

            <Row gutter={[16, 16]} className="simulation-plans">
                {plans.map((plan) => (
                    <Col xs={24} sm={12} lg={6} key={plan.id}>
                        <SimulationPlanCard
                            plan={plan}
                            onUpdate={(updates) => updateSimulationPlan(plan.id, updates)}
                        />
                    </Col>
                ))}
            </Row>
        </div>
    );
}

SimulationPanel.propTypes = {
    plans: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            planName: PropTypes.string.isRequired,
            partials: PropTypes.arrayOf(
                PropTypes.shape({
                    rLevel: PropTypes.number.isRequired,
                    percentage: PropTypes.number.isRequired
                })
            ).isRequired
        })
    ).isRequired,
    tradeCount: PropTypes.number.isRequired,
    onRunSimulation: PropTypes.func.isRequired,
    isLoading: PropTypes.bool
};

SimulationPanel.defaultProps = {
    isLoading: false
};
